module.exports = __webpack_public_path__ + "img/teacher.9c663b01.png";